var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import { Icon } from "../../../UI";

import { Translate } from "../../../I18N";
import { Pill } from "../../../Metadata/components/Pill";








export const UserGroupList = ({
  userGroups,
  handleSelect,
  handleAddGroup,
  className
}) => {
  const [selectedId, setSelectedId] = useState('');
  const addGroup = () => {
    setSelectedId(undefined);
    handleAddGroup();
  };
  const selectRow = (userGroup) => {var _userGroup$_id;
    setSelectedId((_userGroup$_id = userGroup._id) === null || _userGroup$_id === void 0 ? void 0 : _userGroup$_id.toString());
    handleSelect(userGroup);
  };
  return /*#__PURE__*/(
    _jsx("div", { className: "group-list" }, void 0, /*#__PURE__*/
    _jsx("table", { className: className }, void 0, /*#__PURE__*/
    _jsx("thead", {}, void 0, /*#__PURE__*/
    _jsx("tr", {}, void 0, /*#__PURE__*/
    _jsx("th", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Groups")), /*#__PURE__*/

    _jsx("th", { align: "center" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Members")))), /*#__PURE__*/



    _jsx("tbody", {}, void 0,
    userGroups.map((userGroup) => /*#__PURE__*/
    _jsx("tr", {
      className: selectedId === userGroup._id ? 'selected' : '',

      onClick: () => selectRow(userGroup) }, userGroup._id, /*#__PURE__*/

    _jsx("td", {}, void 0, userGroup.name), /*#__PURE__*/
    _jsx("td", { align: "center" }, void 0, /*#__PURE__*/
    _jsx(Pill, { color: "white" }, void 0, /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Icon, { icon: "users" }),
    ` ${userGroup.members.length}`))))))), /*#__PURE__*/







    _jsx("div", { className: `settings-footer ${className}` }, void 0, /*#__PURE__*/
    _jsx("button", { type: "button", className: "btn btn-default", onClick: addGroup }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "plus" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add group"))))));





};